export function mapResetPasswordError(message, t) {
  const msg = String(message || "");
  const isPolicy = /mínimo|minimo|6 caract|maiúscul|maiuscul|uppercase|número|numero|especial|última senha|ultima senha/i.test(
    msg
  );
  if (
    /FE019/i.test(msg) ||
    /token de gera/i.test(msg) ||
    (/token/i.test(msg) && /inv[aá]lido/i.test(msg) && !isPolicy)
  ) {
    return t("login.invalidToken");
  }
  if (
    /confirma[cç][aã]o da senha n[aã]o confere/i.test(msg) ||
    /confirma[cç][aã]o.{0,40}n[aã]o confere/i.test(msg) ||
    /n[aã]o coincid/i.test(msg)
  ) {
    return t("login.confirmMismatch");
  }
  if (isPolicy) {
    return t("login.passwordPolicy.hint");
  }
  if (/\(\/framework\/|Erro TOTVS/i.test(msg)) {
    return t("login.resetError");
  }
  return msg || t("login.resetError");
}

export function resetErrorField(mappedMessage, t) {
  if (mappedMessage === t("login.invalidToken")) return "token";
  if (mappedMessage === t("login.confirmMismatch")) return "confirmationPassword";
  return "";
}
